import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deletedQualification,
    deletedRestoreQualification,
    setQualificationData,
    setQualificationRestoreData,
    updateQualifications,
} from "./qualificationSlice";
import { IEntityWithIDTranslations, IEntityWithTranslations, IErrorResponse, IRootState } from "../../../../types";

const GetQualification = createAsyncThunk("get/qualification", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/qualifications");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;

        dispatch(setQualificationData({ data: response.data, defaultLanguage }));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetQualification = createAsyncThunk(
    "set/qualification",
    async (data: IEntityWithTranslations, { rejectWithValue }) => {
        try {
            const response = await request.post("/qualifications", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteQualification = createAsyncThunk(
    "delete/qualification",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/qualifications/${id}`);

            dispatch(deletedQualification(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditQualifications = createAsyncThunk(
    "edit/qualification",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/qualifications/${data.id}`, data);
            dispatch(updateQualifications(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteQualification = createAsyncThunk(
    "get/delete/qualification",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/qualifications/deleted-items`);

            dispatch(setQualificationRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeleteQualification = createAsyncThunk(
    "restore/delete/qualification",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/qualifications/restore/${id}`);

            dispatch(deletedRestoreQualification(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetQualification,
    SetQualification,
    DeleteQualification,
    EditQualifications,
    GetDeleteQualification,
    RestoreDeleteQualification,
};
